import { render, staticRenderFns } from "./OrticDataHistoryTreeNode.vue?vue&type=template&id=0040e688&scoped=true&"
import script from "./OrticDataHistoryTreeNode.vue?vue&type=script&lang=js&"
export * from "./OrticDataHistoryTreeNode.vue?vue&type=script&lang=js&"
import style0 from "./OrticDataHistoryTreeNode.vue?vue&type=style&index=0&id=0040e688&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0040e688",
  null
  
)

export default component.exports